<template>
  <div class="project">
    <div class="ele-table-tool ele-table-tool-default">
      <el-button @click="addGeneral" type="primary" icon="el-icon-plus" class="ele-btn-icon">添加 </el-button>
      <el-button @click="removeGeneral()" type="danger" icon="el-icon-delete" class="ele-btn-icon">删除 </el-button>
      <el-button type="primary" @click="$refs.generalTable.reload()" class="ele-btn-icon">重置 </el-button>
    </div>
    <ele-data-table ref="generalTable" :config="generalTable" :choose.sync="generalchoose" highlight-current-row height="calc(100vh - 340px)">
      <template #default="{ index }">
        <el-table-column type="selection" width="45" align="center" fixed="left" />
        <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
        <el-table-column prop="egiName" label="常规名称" show-overflow-tooltip />
        <el-table-column prop="createTime" label="录入时间" show-overflow-tooltip />
        <el-table-column label="操作" width="210px" align="center" :resizable="false">
          <template #default="{ row }">
            <el-link @click="editGeneral(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
            <el-link @click="getItem(row.id)" icon="el-icon-view" type="primary" :underline="false">项目管理</el-link>
          </template>
        </el-table-column>
      </template>
    </ele-data-table>
    <!--添加常规-->
    <el-dialog title="添加常规" :visible.sync="showEdit" width="400px" @closed="editForm = {}" :destroy-on-close="true" :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="82px" @keyup.enter.native="saveGeneral">
        <el-form-item label="常规名称:" prop="egiName">
          <el-input v-model="editForm.egiName" placeholder="请输入常规名称" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveGeneral(editForm.id)">确定</el-button>
      </div>
    </el-dialog>
    <!--项目管理-->
    <el-dialog title="提示" :visible.sync="showItem" width="600px" :destroy-on-close="true" :lock-scroll="false">
      <div class="ele-table-tool ele-table-tool-default">
        <el-input v-model="itemValue" placeholder="请输入项目名称" style="width: 150px; margin-right: 10px" />
        <el-button @click="addItem" type="primary" icon="el-icon-plus" class="ele-btn-icon">添加 </el-button>
        <el-button @click="removeItem()" type="danger" icon="el-icon-delete" class="ele-btn-icon">删除 </el-button>
      </div>
      <ele-data-table ref="itemTable" :config="itemTable" :data="itemData" :choose.sync="itemChoose" highlight-current-row>
        <template>
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column prop="egiName" label="项目名称" show-overflow-tooltip align="center" />
          <el-table-column prop="createTime" label="录入时间" show-overflow-tooltip align="center" />
          <el-table-column prop="teacherName" label="操作人" show-overflow-tooltip align="center" />
          <el-table-column label="操作" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="editItem(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-dialog>
    <!--修改项目-->
    <el-dialog title="修改项目" :visible.sync="showEditItem" width="400px" :destroy-on-close="true" :lock-scroll="false">
      <el-form :model="itemForm" ref="itemForm" :rules="itemRules" label-width="82px">
        <el-form-item label="项目名称:" prop="egiName">
          <el-input v-model="itemForm.egiName" placeholder="请输入项目名称" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEditItem = false">取消</el-button>
        <el-button type="primary" @click="updateItem">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { deleteGeneralByIds, saveGeneral, getItemListById, saveItem, deleteItemByIds, updateItem, updateGeneral } from '@/config/api';

  export default {
    name: 'Project',
    data() {
      return {
        classId: null,
        generalTable: {
          // 表格配置
          url: '/educationExamine/getGeneralList',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        generalchoose: [],
        showEdit: false,
        editForm: {},
        editRules: {
          egiName: [{ required: true, message: '请输入常规名称', trigger: 'blur' }],
        },
        generalId: null,
        itemTable: {
          page: false,
        },
        itemData: [],
        showItem: false,
        itemChoose: [],
        itemValue: null,
        showEditItem: false,
        itemForm: {
          egiName: '',
        },
        itemRules: {
          egiName: [{ required: true, message: '请输入常规名称', trigger: 'blur' }],
        },
      };
    },
    methods: {
      // 添加常规打开弹窗
      addGeneral() {
        this.editForm = {};
        this.showEdit = true;
      },
      editGeneral(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      // 保存常规
      saveGeneral(id) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (id == undefined) {
              saveGeneral(formData).then((res) => {
                if (res.data.resCode == 200) {
                  loading.close();
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.showEdit = false;
                  this.$refs.generalTable.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              updateGeneral(formData).then((res) => {
                if (res.data.resCode == 200) {
                  loading.close();
                  this.$message({ type: 'success', message: '修改常规成功' });
                  this.showEdit = false;
                  this.$refs.generalTable.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      // 删除常规
      removeGeneral() {
        if (this.generalchoose.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.generalchoose.map((d) => d.id);
        this.$confirm('确定要删除选中项吗?', '提示', { type: 'warning' }).then(() => {
          let data = new FormData();
          data.append('ids', ids);
          deleteGeneralByIds(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: '已删除' });
              this.$refs.generalTable.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
      // 打开项目管理
      getItem(id) {
        this.generalId = id;
        getItemListById({ id: id }).then((res) => {
          if (res.data.resCode == 200) {
            this.itemData = res.data.data;
            this.showItem = true;
          }
        });
      },
      // 添加项目
      addItem() {
        if (this.itemValue && this.itemValue != '') {
          let data = new FormData();
          data.append('id', this.generalId);
          data.append('egiName', this.itemValue);
          saveItem(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.itemValue = null;
              this.getItem(this.generalId);
            }
          });
        } else {
          this.$message.error('请输入项目名称');
        }
      },
      // 修改项目
      editItem(row) {
        this.itemForm.egiName = row.egiName;
        this.itemForm.id = row.id;
        this.showEditItem = true;
      },
      // 更新
      updateItem() {
        let formData = new FormData();
        for (let key in this.itemForm) {
          if (this.itemForm[key] !== null && this.itemForm[key] !== undefined) {
            formData.append(key, this.itemForm[key]);
          }
        }
        updateItem(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '修改项目成功' });
            this.getItem(this.generalId);
            this.showEditItem = false;
          }
        });
      },
      // 删除项目
      removeItem() {
        if (this.itemChoose.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.itemChoose.map((d) => d.id);
        this.$confirm('确定要删除选中项吗?', '提示', { type: 'warning' }).then(() => {
          let data = new FormData();
          data.append('ids', ids);
          deleteItemByIds(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: '已删除' });
              this.getItem(this.generalId);
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
    },
  };
</script>

<style scoped>
  .project {
    margin-top: 10px;
  }
</style>
